import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  currency_of_exposure: {
    name: 'Currency of the Exposure'
  },
  long_position_value: {
    name: 'Long Position Value'
  },
  short_position_value: {
    name: 'Short Position Value'
  }
};

export function CurrencyExposures({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.CURRENCIES,
    onChangeFund,
    schema: schema.CURRENCIES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.CURRENCIES?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'CURRENCIES',
    columnLables,
    order: 176 as any,
    onAddColumn,
    onDeleteColumn
  });
  return (
    <Table
      id="fca-reporttables-currency-exposures-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
